import {
  type ReplacementConfig,
  type IframeReplacement,
  type Replacement,
} from '../types';

const isIframe = (element: HTMLElement): element is HTMLIFrameElement =>
  element.tagName === 'IFRAME';

export const iframeProcessor: ReplacementConfig<IframeReplacement> = {
  selector: 'iframe',
  processor: (element) => {
    if (isIframe(element)) {
      return {
        type: 'iframe',
        iframe: element,
      };
    }
    return {};
  },
  getKey: (replacement: Replacement) => {
    if (replacement.type === 'iframe') {
      return `iframe:${replacement.iframe.src}:${replacement.iframe.outerHTML}`;
    }
    // This should never happen for iframeProcessor, but TypeScript requires it
    return '';
  },
};
